import * as React from 'react';
import {connect} from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import {AppInitState} from '../../redux/app/appRedux';
import SagaAuthRedux, {SagaAuthInitState} from '../../redux/sagaAuth/sagaAuthRedux';
import TopbarDropdownWrapper from './topbarDropdown.style';


class TopbarUser extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            userProfileFetching: true,
            userProfileResponse: null,
            onlineState: 'unknown'
        };
    }

    public componentWillReceiveProps(newProps) {
        const newState = {
            userProfileResponse: newProps.userProfileResponse,
            userProfileFetching: newProps.userProfileFetching,
            onlineState: 'unknown'
        };

        if (newState.userProfileFetching) {
            newState.onlineState = 'unknown';
        }
        else if (!newState.userProfileFetching && newProps.userProfileResponse) {
            newState.onlineState = 'online';
        }
        else if (!newState.userProfileFetching && !newProps.userProfileResponse) {
            newState.onlineState = 'offline';
        }

        this.setState(newState);
    }

    public hide() {
        this.setState({visible: false});
    }

    public handleVisibleChange() {
        this.setState({
            visible: !this.state.visible
        });
    }

    public render() {
        const content = (
            <TopbarDropdownWrapper className='isoUserDropdown'>
                <a className='isoDropdownLink'>
                    <IntlMessages id='themeSwitcher.settings'/>
                </a>
                <a className='isoDropdownLink'>
                    <IntlMessages id='sidebar.feedback'/>
                </a>
                <a className='isoDropdownLink'>
                    <IntlMessages id='topbar.help'/>
                </a>
                <a
                    className='isoDropdownLink'
                    onClick={this
                        .props
                        .requestLogout
                        .bind(this)}>
                    <IntlMessages id='topbar.logout'/>
                </a>
            </TopbarDropdownWrapper>
        );

        let profileImage: any = null;
        if (this.state.userProfileResponse) {
            profileImage = `data:image/jpeg;base64,${this.state.userProfileResponse.picture}`;
        }

        return (
            <Popover
                content={content}
                trigger='click'
                visible={this.state.visible}
                onVisibleChange={this
                    .handleVisibleChange
                    .bind(this)}
                arrowPointAtCenter={true}
                placement='bottomLeft'>
                <div className='isoImgWrapper'>
                    <img alt='user' src={profileImage}/>
                    <span className={`userActivity ${this.state.onlineState}`}/>
                </div>
            </Popover>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userProfileResponse: state.SagaAuth.userProfileResponse,
        userProfileFetching: state.SagaAuth.userProfileFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestLogout: () => dispatch(SagaAuthRedux.requestLogout())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopbarUser);



// WEBPACK FOOTER //
// ./src/containers/Topbar/topbarUser.tsx